import Form from '@arivaa-react/components/form';

export function EditFooterSocialLinks() {
  const handleSubmit = async (values) => {
    console.log(values);
  };
  return (
    <div className="card">
      <div className="heading">
        <p className="label">Edit Social Links</p>
      </div>
      <div className="edit-form">
        <Form
          renderForm={({ renderElement }) => {
            return (
              <div>
                <div className="item">
                  {renderElement({
                    type: 'text',
                    name: 'title',
                    label: 'Facebook',
                    required: true,
                    options: {
                      initialValue: '',
                    },
                  })}
                </div>
                <div className="item">
                  {renderElement({
                    type: 'text',
                    name: 'title',
                    label: 'Twitter',
                    required: true,
                    options: {
                      initialValue: '',
                    },
                  })}
                </div>
                <div className="item">
                  {renderElement({
                    type: 'text',
                    name: 'title',
                    label: 'Instagram',
                    required: true,
                    options: {
                      initialValue: '',
                    },
                  })}
                </div>
                <div className="item">
                  {renderElement({
                    type: 'text',
                    name: 'title',
                    label: 'Youtube',
                    required: true,
                    options: {
                      initialValue: '',
                    },
                  })}
                </div>
              </div>
            );
          }}
          onSubmit={handleSubmit}
          submitButtonProps={{
            children: 'Save',
          }}
        />
      </div>
    </div>
  );
}
